import React from 'react';
import { Box, Button, Typography } from '@material-ui/core';
import Logo from 'images/logo_black.png';
import { Link, useHistory } from 'react-router-dom';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import styles, { CartContainer, BigTextBlack, BigTitlePurple, BoxContainerText, BoxContainer, BoxContainerOkImg } from './styles';
import { appColors } from 'utils/appColors';

const ConfimationEmailRegister = ({ handleStep }) => {
  const history = useHistory();
  // React.useEffect(() => {
  //   handleStep(2)
  // }, [])

  return (
    <CartContainer flex="1" justifyContent="center" alignItems="center" flexDirection="row" flexWrap="wrap">
      <BoxContainer flex="1" display="flex" flexDirection="row" flexWrap="wrap">
        <BoxContainerOkImg display="flex" alignItems="center">
          <CheckCircleIcon style={{ fontSize: 150, color: appColors.primary }} />
        </BoxContainerOkImg>
        <BoxContainerText flex="1" display="flex" justifyContent="center" flexDirection="column">
          <BigTextBlack>
            CONFIRMAÇÃO DE EMAIL REALIZADA COM SUCESSO!
          </BigTextBlack>
          <BigTitlePurple>
            AGRADECEMOS A PREFERÊNCIA!
          </BigTitlePurple>
        </BoxContainerText>
        <Box flex="1" display="flex" flexDirection="column" alignItems="center" justifyContent="center">
          <img alt="" src={Logo} width={160} />
        </Box>
      </BoxContainer>
    </CartContainer>
  );
};

export default ConfimationEmailRegister;